document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.cch-section');

  sections.forEach((section) => {
    const pouchFront = section.querySelector('.cch-pouch--front');
    const pouchBack = section.querySelector('.cch-pouch--back');
    const fruits = section.querySelectorAll('.cch-fruit');

    let start = null;

    function animate(ts) {
      if (!start) start = ts;
      const t = (ts - start) / 1000;

      if (pouchFront) {
        const y = Math.sin(t * 1.9) * 10;
        const r = -8 + Math.sin(t * 1.3) * 1.2;
        if (window.innerWidth <= 989) {
          pouchFront.style.transform = `translateX(-58%) translateY(${y}px) rotate(${r}deg)`;
        } else {
          pouchFront.style.transform = `translateY(${y}px) rotate(${r}deg)`;
        }
      }

      if (pouchBack) {
        const y = Math.sin(t * 1.7 + 0.7) * 8;
        const r = -10 + Math.sin(t * 1.15 + 0.3) * 1;
        if (window.innerWidth <= 989) {
          pouchBack.style.transform = `translateX(-5%) translateY(${y}px) rotate(${r}deg)`;
        } else {
          pouchBack.style.transform = `translateY(${y}px) rotate(${r}deg)`;
        }
      }

      fruits.forEach((fruit, index) => {
        const speed = 1.1 + index * 0.18;
        const y = Math.sin(t * speed + index) * 8;
        const x = Math.cos(t * (speed * 0.8) + index) * 5;
        const rotate = Math.sin(t * 0.9 + index) * 6;
        fruit.style.transform = `translate(${x}px, ${y}px) rotate(${rotate}deg)`;
      });

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  });
});
